import { useState } from 'react';
import styles from './WithdrawalModal.module.css';
import axios from 'axios';

const WithdrawModal = ({ withdraw, onClose, onReject, onApprove }) => {
  const [txid, setTxid] = useState('');
  const [loading, setLoading] = useState(false);

  if (!withdraw) return null;

  const handleReject = async () => {
    try {
      setLoading(true);
      await axios.put(`/api/admin/withdraw/${withdraw.id}/reject`, {}, { withCredentials: true });
      onReject(withdraw.id);
      onClose();
    } catch (err) {
      alert('Error rejecting withdrawal');
    } finally {
      setLoading(false);
    }
  };
  const handleApprove = async () => {
    if (!txid) return alert('Please enter a TXID');
    try {
      setLoading(true);
      await axios.put(`/api/admin/withdraw/${withdraw.id}/update`, { txid }, { withCredentials: true });
      onApprove(withdraw.id, txid);
      onClose();
    } catch (err) {
      alert('Error approving withdrawal');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2>Withdrawal Details</h2>
        <ul className={styles.detailList}>
          <li><strong>ID:</strong> {withdraw.id}</li>
          <li><strong>User ID:</strong> {withdraw.user_id}</li>
          <li><strong>Amount:</strong> {withdraw.amount}</li>
          <li><strong>Status:</strong> {withdraw.status}</li>
          <li><strong>Coin:</strong> {withdraw.coin_symbol}</li>
          <li><strong>Address:</strong> {withdraw.address}</li>
          <li><strong>Chain:</strong> {withdraw.chain}</li>
          <li><strong>Created At:</strong> {new Date(withdraw.created_at).toLocaleString()}</li>
        </ul>
        {withdraw.status === 'pending' && (
          <div className={styles.actions}>
            <input
              type="text"
              value={txid}
              placeholder="Enter TXID for approval"
              onChange={(e) => setTxid(e.target.value)}
              className={styles.txidInput}
            />
            <button onClick={handleApprove} disabled={loading}>Approve</button>
            <button onClick={handleReject} disabled={loading} className={styles.reject}>Reject</button>
          </div>
        )}
        <div className={styles.footer}>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default WithdrawModal;
